import Main from '@/components/main'
import parentView from '@/components/parent-view'
import {
  titleProjectName,
  titleQuoteName,
  titleQuoteBundleEdit,
  titleQuoteBundleRelations
} from './router-title'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true,
      hideInBread: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      // hideInMenu: true,
      icon: 'md-home',
      notCache: true,
    },
    children: [
      {
        path: '/home',
        name: 'home',
        // redirect: '/project/project-list',
        meta: {
          title: 'menu.home',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/home/home.vue')
      }
    ]
  },
  {
    path: '/quotes',
    name: 'menu.quote',
    redirect: '/quotes',
    meta: {
      title: 'menu.quote.list_title',
      icon: 'logo-usd',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/quotes',
        name: 'menu.quote.list',
        meta: {
          icon: 'logo-usd',
          title: 'menu.quote.quote_list',
          notCache: true,
          hideInBread: true,
          hideInMenu: false
        },
        component: () => import('@/view/quote/quotes.vue')
      },
      {
        path: '_/quotes/group/priced',
        name: 'menu.quote._priced_quotes_group_list',
        redirect: '/quotes/group/priced',
        meta: {
          icon: 'ios-pricetags',
          title: 'menu.quote.priced_quotes_group_list',
          notCache: true
        },
        component: parentView,
        children: [
          {
            path: '/quotes/group/priced',
            name: 'menu.quote.priced_quotes_group_list',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.priced_quotes_group_list',
              notCache: true,
              hideInMenu: true,
              hideInBread: true
            },
            component: () => import('@/view/quote/quote-groups.vue'),
          },
          {
            path: '/quotes/group/priced/new',
            name: 'menu.quote.new_priced_quotes_group',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.new_priced_quotes_group',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/quote/new-quotes-group.vue'),
          },
          {
            path: '/quotes/group/priced/{id}',
            name: 'menu.quote.edit_priced_quotes_group',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.edit_priced_quotes_group',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/quote/edit-quotes-group.vue'),
          }
        ]
      },
      {
        path: '_/quotes/group/estimate',
        name: 'menu.quote._estimate_quotes_group_list',
        redirect: '/quotes/group/estimate',
        meta: {
          icon: 'ios-pricetags',
          title: 'menu.quote.estimate_quotes_group_list',
          notCache: true
        },
        component: parentView,
        children: [
          {
            path: '/quotes/group/estimate',
            name: 'menu.quote.estimate_quotes_group_list',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.estimate_quotes_group_list',
              notCache: true,
              hideInMenu: true,
              hideInBread: true
            },
            component: () => import('@/view/quote/quote-groups.vue'),
          },
          {
            path: '/quotes/group/estimate/new',
            name: 'menu.quote.new_estimate_quotes_group',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.new_estimate_quotes_group',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/quote/new-quotes-group.vue'),
          },
          {
            path: '/quotes/group/estimate/:id',
            name: 'menu.quote.edit_estimate_quotes_group',
            meta: {
              icon: 'ios-pricetags',
              title: 'menu.quote.edit_estimate_quotes_group',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/quote/edit-quotes-group.vue'),
          }
        ]
      },
      {
        path: '/quotes/new',
        name: 'menu.quote.new_quote',
        meta: {
          icon: 'ios-create',
          title: 'menu.quote.new_quote',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/new-quote.vue')
      },
      {
        path: ':quoteId/pdfGenerate',
        name: 'menu.quote.pdf_generate',
        meta: {
          title: 'menu.quote.pdf_generate',
          notCache: true,
          hideInBread: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/quote-preview.vue')
      },
      {
        path: ':quoteId/documents/:documentId',
        name: 'menu.quote.document',
        meta: {
          title: 'menu.quote.document',
          notCache: true,
          hideInBread: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/quote-preview.vue')
      },
      {
        path: ':quoteId/preview/:priceQuotationId',
        name: 'menu.quote.price_quotation_page',
        meta: {
          title: 'menu.quote.price_quotation_page',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/quote-preview')
      },
      {
        path: ':quoteId/view',
        name: 'menu.quote.view',
        redirect: '/quotes/:quoteId',
        meta: {
          icon: 'md-create',
          title: 'menu.quote.edit_quote',
          notCache: true,
          hideInMenu: true
        },
        component: parentView,
        children: [
          {
            path: '/quotes/:quoteId',
            title: 'menu.quote.edit',
            name: 'menu.quote.edit',
            meta: {
              icon: 'md-create',
              notCache: true,
              hideInMenu: true,
              hideInBread: true
            },
            component: () => import('@/view/quote/edit-quote.vue'),
          },
          {
            path: '/quotes/:quoteId/estimators/assembled-costed-bom/:id',
            name: 'menu.estimators.assembled_part_costed_bom',
            meta: {
              icon: 'md-git-branch',
              title: 'menu.estimators.assembled_part_costed_bom',
              notCache: true,
              hideInMenu: true,
              hideInBread: false
            },
            component: () => import('@/view/cost/costed-bom.vue')
          },
        ],
      },
      {
        path: ':quoteId/margin',
        name: 'menu.quote.margin_setting',
        meta: {
          title: 'menu.quote.margin_setting.title',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/quote-margin-setting')
      },
      {
        path: ':quoteId/margin/history/:historyId',
        name: 'menu.quote.margin_setting.history',
        meta: {
          title: 'menu.quote.margin_setting.historyTitle',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/quote/components/forms/margin-breakdown-history-form')
      }
    ]
  },
  {
    path: '/orders',
    name: 'menu.order.main',
    redirect: '/orders',
    meta: {
      title: 'menu.order.list_title',
      icon: 'md-cart',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/orders',
        name: 'menu.order.list',
        meta: {
          icon: 'md-cart',
          title: 'menu.order.list_title',
          notCache: true,
          hideInBread: true
        },
        component: () => import('@/view/order/orders.vue')
      },
      {
        path: '/orders/new',
        name: 'menu.order.new',
        meta: {
          icon: 'md-cart',
          title: 'menu.order.new',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/order/order-new.vue')
      },
      {
        path: '/orders/:id',
        name: 'menu.order.detail',
        meta: {
          icon: 'md-cart',
          title: 'menu.order.detail',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/order/order.vue')
      }
    ]
  },
  {
    path: '/estimators',
    name: 'menu.eastimators',
    redirect: '/estimators/assembled-part-cost',
    meta: {
      title: 'menu.estimators.title',
      icon: 'ios-calculator',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/estimators/assembled-part-cost',
        name: 'menu.estimators.assembled_part_cost_list',
        meta: {
          icon: 'md-flask',
          title: 'menu.estimators.assembled_part_cost',
          notCache: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/assembled-part-cost-estmators.vue')
      },
      {
        path: '/estimators/:id/assembled-part-cost/cost-structure/',
        name: 'menu.estimators.assembled_part_costed_bom_list',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.assembled_part_costed_bom',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/costed-bom.vue')
      },
      {
        path: '/estimators/:id/assembled-part-cost/:costId',
        name: 'menu.estimators.assembled_part_cost_estimator',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.assembled_part_cost',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/assembled-part-cost-estimator.vue')
      },
      {
        path: '/estimators/:id/purchased-parts-cost',
        name: 'menu.estimators.purchased_parts_cost',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.purchased_parts_cost',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/purchased-components-cost-estimator.vue')
      },
      {
        path: '/estimators/pcb-cost',
        name: 'menu.estimators.pcb',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.pcb',
          notCache: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/pcb-cost-list.vue')
      },
      {
        path: '/estimators/pcb-cost/:pcbCostId',
        name: 'menu.estimators.pcb_cost',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.pcb_cost',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/pcb-cost-estimator.vue')
      },
      {
        path: '/estimators/pcb-cost/new',
        name: 'menu.estimators.pcb_cost_new',
        meta: {
          icon: 'md-git-branch',
          title: 'menu.estimators.pcb_cost',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/cost/pcb-cost-estimator.vue')
      },
      {
        path: '/estimators/international-logistics',
        name: 'menu.estimators.international_logistics',
        meta: {
          icon: 'ios-boat',
          title: 'menu.estimators.international_logistics',
          notCache: true,
          hideInBread: false
        }
      }
    ]
  },
  {
    path: '/products',
    name: 'menu.product',
    redirect: '/products',
    meta: {
      title: 'menu.product.product_list',
      icon: 'ios-cube',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/products',
        name: 'menu.product.list',
        meta: {
          icon: 'ios-cube',
          title: 'menu.product.product_list',
          notCache: true,
          hideInMenu: false,
          hideInBread: true
        },
        component: () => import('@/view/product/product-list.vue')
      },
      {
        path: 'new',
        name: 'menu.product.new',
        meta: {
          title: 'menu.product.new_product',
          hideInMenu: true,
          notCache: true
        },
        component: () => import('@/view/product/new-product.vue')
      },
      {
        path: ':productId',
        name: 'menu.product.edit',
        meta: {
          title: 'menu.product.edit_product',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/product/edit-product.vue'),
      }
    ]
  },
  {
    path: '/parts',
    name: 'menu.part',
    redirect: '/parts/electronic-part',
    meta: {
      title: 'menu.part.list_page.title',
      icon: 'md-list-box',
      notCache: true
    },
    component: Main,
    children: [

      {
        path: '_pcb',
        name: 'menu.parts.pcb',
        redirect: '/parts/pcb',
        meta: {
          icon: 'ios-options',
          title: 'menu.pcb.list_title',
          notCache: true,
          hideInBread: false
        },
        component: parentView,
        children: [
          {
            path: '/parts/pcb',
            name: 'menu.pcb.list',
            meta: {
              icon: 'ios-options',
              title: 'menu.pcb.list_title',
              notCache: true,
              hideInBread: true
            },
            component: () => import('@/view/pcb/pcb-list.vue'),
          },
          {
            path: '/parts/pcb/new',
            name: 'menu.pcb.new_pcb',
            meta: {
              icon: 'ios-create',
              title: 'menu.pcb.new_pcb',
              hideInMenu: true,
              notCache: true
            },
            component: () => import('@/view/pcb/pcb-new.vue')
          },
          {
            path: '/parts/pcb/:partId',
            name: 'menu.pcb.edit',
            meta: {
              icon: 'md-list',
              title: 'menu.pcb.edit',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/pcb/pcb-edit.vue')
          }
        ]
      },
      {
        path: '_electronic',
        name: 'menu.parts.electronic_part',
        redirect: '/parts/electronic-part',
        meta: {
          icon: 'ios-options',
          title: 'menu.electronic_part.list_title',
          notCache: true,
          hideInBread: false
        },
        component: parentView,
        children: [
          {
            path: '/parts/electronic-part',
            name: 'menu.electronic_part.list',
            meta: {
              icon: 'ios-options',
              title: 'menu.electronic_part.list_title',
              notCache: true,
              hideInBread: true
            },
            component: () => import('@/view/part/part-list.vue'),
          },
          {
            path: '/parts/electronic-part/new',
            name: 'menu.electronic_part.new',
            meta: {
              icon: 'ios-create',
              title: 'menu.electronic_part.new',
              hideInMenu: true,
              notCache: true
            },
            component: () => import('@/view/part/part-new.vue')
          },
          {
            path: '/parts/electronic-part/:partId',
            name: 'menu.electronic_part.edit',
            meta: {
              icon: 'md-list',
              title: 'menu.electronic_part.edit',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/part/part-edit.vue')
          }
        ]
      },
      {
        path: '_mechanical',
        name: 'menu.parts.mechanical_part',
        redirect: '/parts/mechanical-part',
        meta: {
          icon: 'ios-options',
          title: 'menu.mechanical_part.list_title',
          notCache: true,
          hideInBread: false
        },
        component: parentView,
        children: [
          {
            path: '/parts/mechanical-part',
            name: 'menu.mechanical_part.list',
            meta: {
              icon: 'ios-options',
              title: 'menu.mechanical_part.list_title',
              notCache: true,
              hideInBread: true
            },
            component: () => import('@/view/part/mechanical-part/mechanical-part-list.vue'),
          },
          {
            path: '/parts/mechanical-part/new',
            name: 'menu.mechanical_part.new',
            meta: {
              icon: 'ios-create',
              title: 'menu.mechanical_part.new',
              hideInMenu: true,
              notCache: true
            },
            component: () => import('@/view/part/mechanical-part/mechanical-part-new.vue')
          },
          {
            path: '/parts/mechanical-part/:partId',
            name: 'menu.mechanical_part.edit',
            meta: {
              icon: 'md-list',
              title: 'menu.mechanical_part.edit',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/part/mechanical-part/mechanical-part-edit.vue')
          }
        ]
      },
      {
        path: '_assembled',
        name: 'menu.parts.assembled_part',
        redirect: '/parts/assembled-part',
        meta: {
          icon: 'ios-options',
          title: 'menu.assembled_part.list_title',
          notCache: true,
          hideInBread: false
        },
        component: parentView,
        children: [
          {
            path: '/parts/assembled-part',
            name: 'menu.assembled_part.list',
            meta: {
              icon: 'ios-options',
              title: 'menu.assembled_part.list_title',
              notCache: true,
              hideInBread: true
            },
            component: () => import('@/view/part/assembled-part/assembled-part-list.vue'),
          },
          {
            path: '/parts/assembled-part/new',
            name: 'menu.assembled_part.new',
            meta: {
              icon: 'ios-create',
              title: 'menu.assembled_part.new',
              hideInMenu: true,
              notCache: true
            },
            component: () => import('@/view/part/assembled-part/assembled-part-new.vue')
          },
          {
            path: '/parts/assembled-part/:partId',
            name: 'menu.assembled_part.edit',
            meta: {
              icon: 'md-list',
              title: 'menu.assembled_part.edit',
              notCache: true,
              hideInMenu: true
            },
            component: () => import('@/view/part/assembled-part/assembled-part-edit.vue')
          }
        ]
      },
      {
        path: '/parts/new',
        name: 'menu.part.new',
        meta: {
          title: 'menu.part.new.title',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/part/part-new.vue')
      },
      {
        path: '/parts/:id',
        name: 'menu.part.edit',
        meta: {
          title: 'menu.part.edit.title',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/part/part-edit.vue')
      },
      {
        path: '/part/part-migration-history',
        name: 'menu.part.part_migration_history',
        meta: {
          icon: 'md-clock',
          title: 'menu.part.part_migration_history',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/part/part-migration-history.vue')
      },
      {
        path: '/part/change-log/:id',
        name: 'menu.part.chang_log',
        meta: {
          icon: 'md-clock',
          title: 'menu.part.chang_log',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/part/components/part-audit-changelog.vue')
      },
    ]
  },
  {
    path: '/bom',
    name: 'menu.bom',
    redirect: '/bom/bom-list',
    meta: {
      title: 'menu.bom.title',
      icon: 'ios-grid',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: 'bom-list',
        name: 'menu.bom.bom_list',
        meta: {
          icon: 'md-construct',
          title: 'menu.bom.bom_list',
          notCache: true,
          hideInMenu: false,
          hideInBread: true
        },
        component: () => import('@/view/bom/bom-list.vue')
      },
      {
        path: 'bom-tool/:bomId',
        name: 'menu.bom.view',
        meta: {
          icon: 'md-list',
          title: 'menu.bom.edit_bom',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/bom/bom-composition-tool.vue')
      },
      {
        path: 'bom-upload/:bomId',
        name: 'menu.bom.upload',
        meta: {
          icon: 'md-list',
          title: 'menu.bom.upload',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/bom/bom-upload.vue')
      },
      {
        path: 'bom-upload-map/:bomId',
        name: 'menu.bom.upload_map',
        meta: {
          icon: 'md-list',
          title: 'menu.bom.upload_map',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/bom/bom-upload-map.vue')
      },
      {
        path: 'bom-preview/:fileId',
        name: 'menu.bom.preview',
        meta: {
          icon: 'md-list',
          title: 'menu.bom.preview',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/bom/customer-bom-preview.vue')
      },
      {
        path: 'bom-file-review/:fileId',
        name: 'menu.bom.review',
        meta: {
          icon: 'md-list',
          title: 'menu.bom.review',
          notCache: true,
          hideInMenu: true,
          hideInBread: false
        },
        component: () => import('@/view/bom/bom-review.vue')
      },
      {
        path: 'versions/:bomId/:version?/:version_compare?',
        name: 'menu.bom.versions',
        meta: {
          icon: 'md-time',
          title: 'menu.bom.versions',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/bom/versions/bom-version-snapshot-view.vue'),
      }
    ]
  },
  {
    path: '/companies',
    name: 'menu.companies',
    redirect: '/companies/list',
    meta: {
      title: 'menu.companies.title',
      icon: 'md-pricetags',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/companies/list',
        name: 'menu.companies.list',
        meta: {
          icon: 'md-pricetags',
          title: 'menu.companies.title',
          notCache: true,
          hideInBread: true
        },
        component: () => import('@/view/companies/companies-list.vue')
      }
    ]
  },
  {
    path: '/contacts',
    name: 'menu.contact',
    redirect: '/contact/list',
    meta: {
      title: 'menu.contact.title',
      icon: 'ios-contacts',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/contact/list',
        name: 'menu.contact.list',
        meta: {
          icon: 'ios-contacts',
          title: 'menu.contact.title',
          notCache: true,
          hideInBread: true
        },
        component: () => import('@/view/contact/contacts-list.vue')
      },
      {
        path: '/contact/new',
        name: 'menu.contact.new',
        meta: {
          icon: 'ios-contact',
          title: 'menu.contact.new',
          notCache: true,
          hideInBread: false,
          hideInMenu: true
        },
        component: () => import('@/view/contact/new-contact.vue')
      },
      {
        path: '/contact/:contactId',
        name: 'menu.contact.edit_contact',
        meta: {
          icon: 'ios-contact',
          title: 'menu.contact.edit_contact',
          notCache: true,
          hideInBread: false,
          hideInMenu: true
        },
        component: () => import('@/view/contact/edit-contact.vue')
      }
    ]
  },
  {
    path: '/account',
    name: 'menu.account',
    redirect: '/account/list',
    meta: {
      title: 'menu.account.title',
      icon: 'ios-contact',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/account/list',
        name: 'menu.account.list',
        meta: {
          icon: 'ios-contact',
          title: 'menu.account.title',
          notCache: true,
          hideInBread: true
        },
        component: () => import('@/view/account/account-list.vue')
      },
      {
        path: '/account/:accountId',
        name: 'menu.account.edit_account',
        meta: {
          icon: 'ios-contact',
          title: 'menu.account.edit_account',
          notCache: true,
          hideInBread: false,
          hideInMenu: true
        },
        component: () => import('@/view/account/edit-account.vue')
      }
    ]
  },
  {
    path: '/quality',
    name: 'menu.quality',
    redirect: '/quality/scrap',
    meta: {
      title: 'menu.quality.title',
      icon: 'md-pie',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/quality/scrap',
        name: 'menu.quality.scrap',
        meta: {
          icon: 'md-pie',
          title: 'menu.quality.scrap.title',
          notCache: true,
          hideInBread: false,
          hideInMenu: true
        },
        component: () => import('@/view/quality/scrap/scrap-list.vue')
      }
    ]
  },
  {
    path: '/people',
    name: 'menu.people.main',
    redirect: '/people',
    meta: {
      title: 'menu.people.list_title',
      icon: 'md-people',
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/people',
        name: 'menu.people.list',
        meta: {
          icon: 'md-people',
          title: 'menu.people.list_title',
          notCache: true,
          hideInBread: true
        },
        component: () => import('@/view/people/people-list.vue')
      },
      {
        path: '/people/new',
        name: 'menu.people.new',
        meta: {
          icon: 'md-people',
          title: 'menu.people.new',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/people/people-new.vue')
      },
      {
        path: '/people/:id',
        name: 'menu.people.detail',
        meta: {
          icon: 'md-people',
          title: 'menu.people.detail',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/people/people.vue')
      },
      {
        path: '/people/sync',
        name: 'menu.people.sync',
        meta: {
          icon: 'md-people',
          title: 'menu.people.sync',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/people/people-list.vue')
      }
    ]
  },
  {
    path: '/user',
    name: 'menu.user',
    redirect: '/user/my-tasks',
    meta: {
      title: 'menu.user.title',
      icon: 'md-person',
      hideInMenu: true,
      notCache: true
    },
    component: Main,
    children: [
      {
        path: '/user/my-profile',
        name: 'menu.user.my_profile',
        meta: {
          icon: 'ios-paper',
          title: 'menu.user.my_profile',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/user/my-profile.vue')
      },
      {
        path: '/user/my-tasks',
        name: 'menu.user.my_tasks',
        meta: {
          icon: 'md-list',
          title: 'menu.user.my_tasks',
          notCache: true,
          hideInMenu: true
        },
        component: () => import('@/view/task/my-todos.vue')
      }
    ]
  },
  {
    path: '/error_logger',
    name: 'error_logger',
    meta: {
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'error_logger_page',
        name: 'error_logger_page',
        meta: {
          icon: 'ios-bug',
          title: '错误收集',
          access: ['access_pricing']
        },
        component: () => import('@/view_kickstart/single-page/error-logger.vue')
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          icon: 'md-notifications',
          title: '消息中心'
        },
        component: () => import('@/view_kickstart/single-page/message/index.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
